module.exports = __webpack_public_path__ + "media/images/content/pic_direction_nw-2baada097b81d290ccb42d08f503ac9f.svg";